import { livyJson } from 'src/lib/livyApi';
export async function listConversations() {
  const _await$livyJson = await livyJson('/logs/conversations'),
    conversations = _await$livyJson.conversations;
  return conversations;
}

/**
 * Rebuilds a thread from the transcript tier. Ordered by the stored sequence key rather than by
 * timestamp, because two messages in the same turn can share a second and would otherwise swap.
 */
export async function loadConversation(id) {
  const _await$livyJson2 = await livyJson("/logs/conversations/".concat(id, "?transcript=true")),
    items = _await$livyJson2.items;
  return items.filter(r => r.tier === 'transcript' && (r.role === 'user' || r.role === 'assistant')).sort((a, b) => String(a.sk).localeCompare(String(b.sk))).map(r => {
    var _r$content;
    return {
      role: r.role,
      content: (_r$content = r.content) !== null && _r$content !== void 0 ? _r$content : ''
    };
  });
}

/** A thread is named by its first question, which is what a person actually remembers it by. */
export const titleFor = (messages, fallback) => {
  var _messages$find;
  const first = (_messages$find = messages.find(m => m.role === 'user')) === null || _messages$find === void 0 || (_messages$find = _messages$find.content) === null || _messages$find === void 0 ? void 0 : _messages$find.trim();
  if (!first) return fallback;
  return first.length > 60 ? "".concat(first.slice(0, 57), "...") : first;
};